import companyChangeProcesses from "config/companyChangeProcesses";
import RadioCards from "components/lib/Global/RadioCards";
import { RadioGroup } from "@headlessui/react";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AccountReferenceDate from "./AccountReferenceDate";
import ArticlesOfAssociation from "./ArticlesOfAssociation";
import BankAccount from "./BankAccount";
import ConversionOfACompany from "./ConversionOfACompany";
import NameOfACompany from "./NameOfACompany";
import OfficialsShareholdersAuthorisedPersons from "./OfficialsShareholdersAuthorisedPersons";
import RegisteredAddress from "./RegisteredAddress";
import ShareCapital from "./ShareCapital";
import StrikeOff from "./StrikeOff";
import ChangesContext from "context/ChangesContext";
import { ManageModuleContext } from "context/ManageCompanyModuleContext";

import BreadCrumb from "components/lib/Global/BreadCrumb";
import RecentChangesTable from "./SharedComponents/RecentChangesTable";
import RecentChangesAndApprovals from "./RecentChangesAndApprovals";
import TransactionEditContext from "context/TransactionEditContext";
import CompanyDashboardContext from "context/CompanyDashboardContext";
import { getAllInitiateTransactionChangeAsync } from "state/slices/initiateTransactionChange";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Constants } from "config/constants";
import { Roles_Permissions_Constants } from "config/roles-permissions";

const Changes = (props) => {
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const isInChangesModule = true;
  const { initiatedTransactions } = useSelector(
    (state) => state.initiatedTransactionsSlice
  );
  const { company, dashboardPermissions, dashboardRoles, designation } =
    useSelector((state) => state.companyDashboardSlice);

  const {
    resetSelectedChangesData,
    selectedChangesTab,
    selectedOfficial,
    setSelectedOfficial,
    showChangesAndApprovals,
  } = useContext(CompanyDashboardContext);
  const { isInTransactionEditContext, transactionProcess } = useContext(
    TransactionEditContext
  );
  const [selectedProcess, setselectedProcess] = useState(
    selectedChangesTab ? selectedChangesTab : ""
  );
  const [shareCapitalOption, setshareCapitalOption] = useState("");

  const filteredTransactions =
    initiatedTransactions?.items.filter((transaction) => {
      return (
        transaction.changeType &&
        Object.values(Constants.MAINTAIN_COMPANY_DRAFT_STATUS).includes(
          transaction.status
        )
      );
    }) || [];

  const [showRecentChanges, setshowRecentChanges] = useState(
    showChangesAndApprovals ? showChangesAndApprovals : false
  );
  const [newRequestInitiated, setnewRequestInitiated] = useState(false);

  const { handleBackToManageYourCompanyDashboard } =
    useContext(ManageModuleContext);

  const isRegistrar = dashboardRoles.some(
    (role) =>
      role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.REGISTRAR
  );

  const isUploader = dashboardRoles.some(
    (role) => role.name === Roles_Permissions_Constants.DASHBOARD_ROLES.UPLOADER
  );

  const filteredChangeProcesses = companyChangeProcesses.filter((process) => {
    if (isRegistrar || isUploader) {
      return true;
    } else {
      return (
        process.id === "OfficialsShareholdersAuthorisedPersons" ||
        (process.id === "ShareCapital" &&
          Constants.MAINTAIN_COMPANY_SHAREHOLDERS_DESIGNATIONS.includes(
            designation
          ))
      );
    }
  });

  const handleBackToChangesDashboard = () => {
    setshowRecentChanges(false);
    setselectedProcess("");
  };

  const handleBackToShareCapitalDashboard = () => {
    setshareCapitalOption("");
  };
  const [isBackFromChangesTable, setisBackFromChangesTable] = useState(false);
  const [selectedChangeProcess, setSelectedChangeProcess] = useState({});

  const pages = [
    { name: "Home", href: "#", current: false },
    {
      name: "Maintain a company",
      current: false,
      href: "#",
      handleClick: handleBackToManageYourCompanyDashboard,
    },
    {
      name: "Changes",
      current: selectedProcess?.id ? false : true,
      href: null,
      handleClick: selectedProcess?.id ? handleBackToChangesDashboard : false,
    },
    selectedProcess?.id
      ? {
          name: selectedProcess.id,
          current: shareCapitalOption?.id ? false : true,
          handleClick: shareCapitalOption?.id
            ? handleBackToShareCapitalDashboard
            : false,
          href: null,
        }
      : null,
    shareCapitalOption?.id
      ? {
          name: shareCapitalOption.id,
          current: true,
          href: null,
        }
      : null,
  ];

  const handleCompanyProcessSelection = (process) => {
    resetSelectedChangesData();
    setselectedProcess(process);
  };

  const displayRecentChangesAndApprovals = () => {
    setshowRecentChanges(true);
  };

  const handleBackFromChangesTable = () => {
    setisBackFromChangesTable(true);
    if (selectedOfficial) {
      setselectedProcess({
        id: "OfficialsShareholdersAuthorisedPersons",
      });
    } else {
      setSelectedChangeProcess(selectedProcess);
    }
  };

  const hideRecentChanges = () => {
    handleBackFromChangesTable();
    setshowRecentChanges(false);
  };

  const createBatchNumber = () => {
    alert("Batch number created!");
  };

  const handleInitiateNewRequest = () => {
    createBatchNumber();
    resetSelectedChangesData();
    setselectedProcess("");
    setshowRecentChanges(false);
    setnewRequestInitiated(true);
    setisBackFromChangesTable(false);
  };

  useEffect(() => {
    if (isInTransactionEditContext) {
      setselectedProcess(transactionProcess);
    }
  }, [isInTransactionEditContext]);
  return (
    <ChangesContext.Provider
      value={{
        handleBackToChangesDashboard,
        isInChangesModule,
        displayRecentChangesAndApprovals,
        isBackFromChangesTable,
        selectedChangeProcess,
      }}
    >
      <div className="text-sflPrimary">
        {!selectedProcess?.id && !showRecentChanges && (
          <RadioGroup onChange={handleCompanyProcessSelection} className="my-4">
            <RadioGroup.Label className="text-base">
              <div>
                <div className="bg-white container mx-auto px-4 mb-8">
                  <div className="">
                    <BreadCrumb pages={pages} />
                  </div>
                </div>
                <h2 className="pb-4 font-semibold text-title5">
                  Changes Application
                </h2>
                <h1 className="font-medium">
                  Changes section, here you can update your company details or
                  information if you want
                </h1>
              </div>
            </RadioGroup.Label>
            <RadioCards options={filteredChangeProcesses} />
          </RadioGroup>
        )}
        {showRecentChanges && (
          <RecentChangesAndApprovals
            hideRecentChangesAndApprovals={hideRecentChanges}
            handleInitiateNewRequest={handleInitiateNewRequest}
          />
        )}
        {!showRecentChanges && selectedProcess?.id ? (
          <div>
            <div className="bg-white container mx-auto px-4">
              <div className="">
                <BreadCrumb pages={pages} />
              </div>
            </div>
            <div>
              {selectedProcess.id ===
                "OfficialsShareholdersAuthorisedPersons" && (
                <OfficialsShareholdersAuthorisedPersons
                  selectedOfficial={selectedOfficial}
                />
              )}
              {selectedProcess.id === "AccountReferenceDate" && (
                <AccountReferenceDate />
              )}
              {selectedProcess.id === "ArticlesOfAssociation" && (
                <ArticlesOfAssociation />
              )}
              {selectedProcess.id === "BankAccount" && <BankAccount />}
              {selectedProcess.id === "ConversionOfACompany" && (
                <ConversionOfACompany />
              )}
              {selectedProcess.id === "NameOfACompany" && <NameOfACompany />}
              {selectedProcess.id === "RegisteredAddress" && (
                <RegisteredAddress />
              )}
              {selectedProcess.id === "ShareCapital" && (
                <ShareCapital
                  shareCapitalOption={shareCapitalOption}
                  setshareCapitalOption={setshareCapitalOption}
                  isUploader={isUploader}
                  isRegistrar={isRegistrar}
                />
              )}
              {selectedProcess.id === "StrikeOff" && <StrikeOff />}
            </div>
          </div>
        ) : null}
      </div>
    </ChangesContext.Provider>
  );
};

export default Changes;
